<template>
  <div class="top-products">
    <doughnut-chart :chart-data="charData"></doughnut-chart>
  </div>
</template>

<script>
import DoughnutChart from "@/components/admin/dashboard/charts/DoughnutChart";
import chartMixin from "@/mixins/dashboard/chartMixin";
import { drinksCollection } from "@/collections/drinks";
import { dessertCollection } from "@/collections/dessert";
import { foodCollection } from "@/collections/food";
const MAX_RESULTS = 10;

export default {
  name: "TopProductsChart",
  components: { DoughnutChart },
  mixins: [chartMixin],
  props: {
    orders: {
      type: Array,
      default: null
    },
    productTypeSelected: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      drinksCollection: [],
      foodCollection: [],
      dessertCollection: []
    };
  },
  firestore() {
    return {
      drinksCollection: drinksCollection,
      foodCollection: foodCollection,
      dessertCollection: dessertCollection
    };
  },
  computed: {
    charData() {
      let resultSum = {};
      let productsArray = [];

      this.orders.forEach(orderDate => {
        productsArray = [...productsArray, ...orderDate.products];
      });

      productsArray.forEach(order => {
        if (
          this.productTypeSelected === "all" ||
          order.type === this.getOrderType(this.productTypeSelected)
        ) {
          let key = order.product_id;
          resultSum[key] = !resultSum[key]
            ? order.count
            : resultSum[key] + order.count;
        }
      });

      let resultArraySorted = [];
      Object.values(resultSum).forEach(d => {
        resultArraySorted.push(d);
      });

      resultArraySorted = resultArraySorted.sort().reverse();
      resultArraySorted =
        resultArraySorted.length > MAX_RESULTS
          ? resultArraySorted.slice(0, MAX_RESULTS)
          : resultArraySorted;

      let resultObj = {};
      let maxResults = 0;
      let sumData = 0;
      Object.entries(resultSum).forEach(([key, value]) => {
        if (maxResults === MAX_RESULTS) {
          return;
        }
        if (resultArraySorted.includes(value)) {
          resultObj[key] = value;
          sumData += value;
          maxResults++;
        }
      });

      let products = [
        ...this.foodCollection,
        ...this.drinksCollection,
        ...this.dessertCollection
      ];

      let labels = [];
      Object.keys(resultObj).forEach(productId => {
        let foundProduct = products.find(item => item.id === productId);
        if (foundProduct) {
          labels.push(foundProduct.name);
        }
      });

      let data = Object.values(resultObj);
      let dataPercentage = [];
      data?.forEach(d => {
        dataPercentage.push(((d * 100) / sumData).toFixed(1));
      });

      return {
        labels: labels,
        datasets: [
          {
            data: dataPercentage,
            backgroundColor: [
              "#ad2664",
              "#e2662e",
              "#953c86",
              "#20c997",
              "#02d6ef",
              "#7b00ff",
              "#ba72bf",
              "#99635f",
              "#3ABC88",
              "#0677e8"
            ],
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
